import { Placeholder } from 'react-bootstrap'

type ReactVideoListSkeletonProps = {
  overrideHeight?: boolean
}

type SkeletonStyles = {
  height?: string
  width: string
  backgroundColor: string
  borderRadius: string
}

const ReactVideoListSkeleton = (props: ReactVideoListSkeletonProps) => {
  const { overrideHeight = false } = props
  const styles: SkeletonStyles = { width: '100%', backgroundColor: 'grey', borderRadius: '20px' }
  if (!overrideHeight) {
    styles.height = '333px'
  }
  return (
    <div className='article react-video-list'>
      <div className='article-container responsive-size' data-testid='video-list-container'>
        <div key='image-container' className='image-container'>
          <Placeholder xs={12} style={styles} />
        </div>
        <div className='heading'>
          <Placeholder xs={12} />
        </div>
        <div className='headingDescription'>
          <Placeholder xs={12} />
        </div>
      </div>
    </div>
  )
}

export default ReactVideoListSkeleton
